<template>
  <herinneringsjuwelen />
</template>

<script>
import Herinneringsjuwelen from '../components/KeuzesUitvaart/Herinneringsjuwelen.vue'

export default {
  name: 'HerinneringsjuwelenView',
  components: {
    Herinneringsjuwelen
  }
}
</script>
